<template>
  <div class="padded" style="clear: both;">

    <invoice-summary />

    <el-row :gutter="gutter">
      <el-col align="center" :span="24">
        <data-table
          title="Financial Statement"
          url="report/finance/summary"
          table-ref="finance-summary"
          :show-search="false"
          :show-refresh="true"
          track-by="name"
          :fields="fields"
          />
      </el-col>
    </el-row>

  </div>
</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

import InvoiceSummary from '@/components/dashboard/finance/InvoiceSummary'

export default {

  mixins: [SiteMixins],

  components: {
    InvoiceSummary
  },

  data () {
    return {
      gutter: 16,
      fields: [
        {
          name: 'name',
          title: 'Company'
        },
        {
          name: 'category',
          title: 'Invoice Type',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'ledger',
          title: 'Ledger',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'subtotal',
          title: 'Sub-Total',
          callback: this.formatInteger,
          visible: this.showTax(),
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'tax',
          title: this.taxLabel,
          callback: this.formatInteger,
          visible: this.showTax(),
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          titleClass: 'text-primary',
          dataClass: 'text-primary',
          callback: this.formatInteger
        },
        {
          name: 'totalPaid',
          title: 'Paid',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-success'
        },
        {
          name: 'outstanding',
          title: 'O/S',
          callback: this.formatInteger,
          titleClass: 'hidden-sm-and-down text-warning',
          dataClass: 'hidden-sm-and-down text-warning'
        }
      ]
    }
  }
}

</script>
